import {Button} from '@guestapp/old-ui-kit';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  margin-top: 24px;
`;
